import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-login',
  templateUrl: './skeleton-login.component.html',
  styleUrls: ['./skeleton-login.component.scss']
})
export class SkeletonLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
